import * as React from "react";

import ConfirmModal from "../../core/ConfirmModal/ConfirmModal";

import { ITranslationProps, translateComponent } from "../../helpers/translation";

interface ILicenseKeyEditMasterEditProps extends ITranslationProps {
    isActive: boolean;
    label: string;
    activateConfirmationMessage: string;
    inactivateConfirmationMessage: string;
    onConfirmation: () => void;
}

interface ILicenseKeyEditMasterEditState {
    showModal: boolean;
    activateModalMessage: string;
}

class LicenseKeyEdit extends React.Component<ILicenseKeyEditMasterEditProps, ILicenseKeyEditMasterEditState> {

    constructor(props: ILicenseKeyEditMasterEditProps) {
        super(props);

        this.state = {
            showModal: false,
            activateModalMessage: "",
        };

        this.onActivateClick = this.onActivateClick.bind(this);
        this.onInactivateClick = this.onInactivateClick.bind(this);
        this.closeActivateModal = this.closeActivateModal.bind(this);
    }

    public render() {
        return (
            <div>
                <div className="form-group">
                    <label>{this.props.label}</label>
                    <div className="input-group">
                        <div className="form-control">{this.props.isActive ? this.props.t("Global.Active") : this.props.t("Global.Inactive") }</div>
                        <div className="input-group-append">
                            {!this.props.isActive && <button type="button" className="btn btn-secondary" onClick={this.onActivateClick}>{this.props.t("ActiveStatusControl.ActivateButton")}</button>}
                            {this.props.isActive && <button type="button" className="btn btn-secondary" onClick={this.onInactivateClick}>{this.props.t("ActiveStatusControl.InactivateButton")}</button>}
                        </div>
                    </div>
                </div>

                <ConfirmModal
                    onRequestClose={this.closeActivateModal}
                    onConfirmation={this.props.onConfirmation}
                    isOpen={this.state.showModal}
                    title={this.props.t("Global.Confirm")}
                    message={this.state.activateModalMessage} />
            </div>
        );
    }

    private closeActivateModal() {
        this.setState({ showModal: false });
    }

    private onActivateClick() {
        this.setState({
            showModal: true,
            activateModalMessage: this.props.activateConfirmationMessage
        });
    }

    private onInactivateClick() {
        this.setState({
            showModal: true,
            activateModalMessage: this.props.inactivateConfirmationMessage
        });
    }
}

export default translateComponent(LicenseKeyEdit);



// WEBPACK FOOTER //
// ./src/core/ActiveStatusControl/ActiveStatusControl.tsx